/* eslint-disable jsx-a11y/label-has-associated-control */
import Path from '@leverege/path'
import classnames from 'classnames'
import Editor from '@monaco-editor/react'
import React from 'react'
import PropTypes from 'prop-types'
import IFrame from 'react-iframe'
import { Base64 } from 'js-base64';
// import { Flex } from '~/views'
import { NumericInput, TextInput, Flex } from '@leverege/ui-elements'

import style from './style.css'

export default class TemplateDataEditor extends React.Component {

  static propTypes = {
    intent : PropTypes.object,
    onChange : PropTypes.func.isRequired,
  }

  static defaultProps = {
    intent : null
  }

  onChangeTemplate = ( text ) => {
    let val = text

    try {
      val = JSON.stringify( JSON.parse( text ), null, 2 )
    } catch ( err ) {
      
    }
    this.onChange( { data : 'data', value : val } )
  }

  onChange = ( { value, data } ) => {
    const { intent, intentType, onChange } = this.props 
    let v = value
    if ( Number.isNaN( Number( v ) ) ) {
      v = null
    }
    const cIntent = Path.copy( data, intent, value )
    onChange( { value : cIntent, path : data } )
  }

  render() {

    const { intent, intentType, headerText, showSubject = false } = this.props
    if ( intent == null ) {
      return <div />
    }

    // const { id, type, data, limitOptions } = intent
    const { data = '', limitOptions = {}, subject } = intent
  
    return (
      <Flex className={style.editorFlex} variant="vSpace" direction="column" align="stretch" justify="flex-start">
        <Flex className={classnames( style.headerRow )} variant="vSpace" direction="row" justify="space-between">
          { headerText || <div className={style.header}>Handlebar Template</div> }
        </Flex>
        { showSubject && (
          <Flex justify="flex-start">
            <label>Subject</label>
            <TextInput
              style={{ flex : '1 1 auto' }}
              eventData="subject"
              hint="Subject"
              value={subject}
              changeOnReturn 
              onChange={this.onChange} />
          </Flex>
        ) }
        <Flex className={style.editorPreview}>
          <Editor
            options={{
              minimap : {
                enabled : false
              }
            }}
            className={style.editor}
            height="100%"
            width="50%"
            defaultLanguage={intentType === 'email' || intentType === 'sms' ? 'handlebars' : 'json'}
            value={data}
            onChange={this.onChangeTemplate}
            theme="light" />
          <div className={style.wrap}>
            <IFrame className={style.iframe} url={`data:text/html;base64,${Base64.encode( data )}`} />
          </div>
        </Flex>
        <Flex direction="column" variant="vSpace" align="flex-start" className={style.limitOptions}>
          <div className={style.header}>Limiting options</div>
    
          <Flex justify="flex-start">
            <label>Allow</label>
            <NumericInput
              eventData="limitOptions/count"
              hint="count"
              value={limitOptions.count}
              changeOnReturn 
              min={1}
              onChange={this.onChange} />
            <label>messages in</label>
            <NumericInput
              eventData="limitOptions/period"
              hint="hours"
              value={limitOptions.period}
              changeOnReturn 
              float
              min={0.0001}
              onChange={this.onChange} />
            <label>hours</label>
          </Flex>
          <Flex justify="flex-start">
            <label>Once exceeded, prohibit messages for</label>
            <NumericInput
              eventData="limitOptions/duration"
              hint="hours"
              value={limitOptions.duration}
              changeOnReturn
              float
              min={0.0001}
              onChange={this.onChange} />
            <label>hours</label>
          </Flex>
        </Flex>
      </Flex>
    ) 
  }
}
